// The tuner (design §7 Tools): mic needle, nearest string and reference tones.
export const id = 'tuner';
export const name = 'Tuner';
export const purpose = 'Tune each string with the mic, or by ear with reference tones.';
export const icon = '♪';
export const order = 10;
